import { proxy } from 'valtio'

export const sandboxProjectStore = proxy({
  isSandboxProject: false,
})
